<div class="member-select-panel__search">
  <ocp-themed-icon class="member-select-panel__search-icon" name="search.svg" />
  <input
    #searchInput
    type="text"
    class="member-select-panel__search-input"
    [placeholder]="'assignee-dropdown.type-name' | translate"
    [value]="searchQuery()"
    (input)="onSearchInput($event)"
    (keydown)="onSearchKeydown($event)"
  />
</div>

<ul
  class="member-select-panel__list"
  [class.member-select-panel__list--has-options]="filteredOptions().length > 0"
>
  @for (option of filteredOptions(); track trackByValue($index, option); let i = $index) {
    <li class="member-select-panel__list-item">
      <button
        #optionElement
        type="button"
        class="member-select-panel__option"
        [class.member-select-panel__option--selected]="isSelected(option)"
        [class.member-select-panel__option--focused]="focusedIndex() === i"
        [attr.aria-pressed]="isSelected(option)"
        (click)="toggleOption(option, $event)"
        (keydown)="onOptionKeydown($event, option, i)"
      >
        <span class="member-select-panel__checkmark-area">
          @if (isSelected(option)) {
            <ocp-themed-icon
              class="member-select-panel__checkmark"
              name="checkmark.svg"
              [size]="16"
            />
          }
        </span>
        <ocp-avatar
          [userInitials]="option.initials"
          [colorSeed]="option.email"
          size="md"
          class="member-select-panel__option-avatar"
        />
        <div class="member-select-panel__option-text">
          <span class="member-select-panel__option-name">{{ option.label }}</span>
          @if (option.email) {
            <span class="member-select-panel__option-email">{{ option.email }}</span>
          }
        </div>
      </button>
    </li>
  }
</ul>
